import React, { useContext } from 'react';
import { useMediaQuery } from 'react-responsive';
import { Skeleton } from '@oneaudi/unified-web-components';
import { vehicleContext } from '../VehicleProvider';
import removeYearFromModelName from '../../utils/removeYearFromModelName';
import { H1, Year, ModelMake, H2, Mileage } from './VehicleInfo.style';

const VehicleInfo: React.FC = () => {
  const { vehicleData, market } = useContext(vehicleContext);

  const modelAndMake = removeYearFromModelName(vehicleData?.modelYear, vehicleData?.modelName);

  const isCanadian = market === 'ca' || market === 'cauc';
  const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1299 });
  const isCpo = vehicleData?.warrantyType && vehicleData.warrantyType.includes('plus');
  const showDistanceTop = Boolean(isCpo) && !isTablet && market === 'usuc';

  // FIXME: Delete this function when backend will be fixed
  const deleteHPfromTrim = (trim: string) => {
    if (!trim || (!trim.includes('HP') && !trim.includes('kW'))) return trim;

    // Handle any word followed by numbers and HP/kW
    const powerPattern = /\w+\d+(?:HP|kW)/g;
    const result = powerPattern.test(trim) ? trim.replace(powerPattern, '') : trim;

    // Handle numbers followed by HP/kW
    const trimWords = result.split(' ');
    const filteredWords = trimWords.reduce((acc: string[], word, index) => {
      const nextWord = trimWords[index + 1];
      const isNumberWithUnit =
        /^\d+$/.test(word.replace(',', '')) && (nextWord === 'HP' || nextWord === 'kW');

      if (isNumberWithUnit || word === 'HP' || word === 'kW') {
        return acc;
      }
      return [...acc, word];
    }, []);

    return filteredWords.join(' ').replace(/\s+/g, ' ').trim();
  };

  return (
    <>
      <H1>
        <Year data-vehicle-model-year={vehicleData?.modelYear} data-testid="model-year">
          {vehicleData?.modelYear || <Skeleton variant="rectangular" />}
        </Year>
        <ModelMake data-vehicle-model-name={modelAndMake} data-testid="model-make">
          {' '}
          {modelAndMake || <Skeleton variant="rectangular" />}
        </ModelMake>
      </H1>
      <H2 data-vehicle-trim={vehicleData?.trimName} data-testid="trim-name" usCPO={showDistanceTop}>
        {vehicleData?.trimName ? (
          deleteHPfromTrim(vehicleData.trimName)
        ) : (
          <Skeleton variant="rectangular" />
        )}
      </H2>
      {vehicleData?.modelMileage && (
        <Mileage data-testid="mileage">
          {vehicleData.modelMileage} {isCanadian ? 'km' : 'miles'}
        </Mileage>
      )}
    </>
  );
};

export default VehicleInfo;
